var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('room-type-form',{model:{value:(_vm.roomType),callback:function ($$v) {_vm.roomType=$$v},expression:"roomType"}})}
var staticRenderFns = []

export { render, staticRenderFns }